import styled from "styled-components";

import { Button } from "@components/General/Button";

import { transition } from "@ui/helpers";

export const Table = styled.table`
  --table-padding-x: ${props => props.theme.spacing.spacing_12};
  --table-padding-right: ${props => props.theme.spacing.spacing_4};
  --table-padding-left: ${props => props.theme.spacing.spacing_12};
  --table-cell-padding-x: ${props => props.theme.spacing.spacing_8};
  --table-header-color: ${props => props.theme.palette.grey800};
  --table-text-color: ${props => props.theme.palette.grey800};
  --table-background-color: ${props => props.theme.palette.white};
  --table-counter: table-counter;

  ${props => props.theme.breakpoints.tablet} {
    --table-padding-left: ${({ theme }) =>
      `calc(${theme.spacing.spacing_24} + ${theme.spacing.spacing_12})`};
  }

  counter-reset: var(--table-counter);
  width: 100%;
  color: var(--table-text-color);
  text-align: right;
  border-radius: ${props => props.theme.border.radius.base};
  border-collapse: collapse;
  overflow: hidden;

  ${props => props.theme.breakpoints.tablet} {
    text-align: center;
  }

  td,
  th {
    padding-left: var(--table-cell-padding-x);
    padding-right: var(--table-cell-padding-x);

    &:first-child {
      text-align: left;
      padding-left: var(--table-padding-left);
    }

    &:last-child {
      padding-left: 0;
      padding-right: var(--table-padding-right);

      ${props => props.theme.breakpoints.tablet} {
        padding-right: 0;
      }
    }
  }
`;

export const THead = styled.thead`
  background-color: var(--table-background-color);

  th {
    padding-top: ${props => props.theme.spacing.spacing_16};
    padding-bottom: ${props => props.theme.spacing.spacing_4};
    white-space: nowrap;

    ${props => props.theme.breakpoints.tablet} {
      min-width: 76px;
    }

    &:first-child {
      width: 100%;
    }

    &:last-child {
      min-width: auto;
      padding-left: 0;
    }
  }
`;

export const TBody = styled.tbody`
  counter-increment: var(--table-counter);

  &:last-child {
    border-bottom: ${props => props.theme.spacing.spacing_16} solid white;
  }
`;

export const TransparentRow = styled.tr`
  [data-opened="true"] + [data-opened] & {
    height: 1px;
  }
`;

export const TBodyHeader = styled.tr`
  background-color: var(--table-background-color);

  td {
    padding-top: ${props => props.theme.spacing.spacing_8};
    padding-bottom: ${props => props.theme.spacing.spacing_2};
  }
`;

export const ContentRow = styled.tr`
  background-color: var(--table-background-color);
  display: none;

  [data-opened="true"] & {
    display: table-row;
  }

  & + & {
    border-top: 1px solid ${props => props.theme.palette.blue50};
  }

  td {
    padding-top: 6px;
    padding-bottom: ${props => props.theme.spacing.spacing_4};
  }

  &:last-child td {
    padding-bottom: ${props => props.theme.spacing.spacing_24};
  }
`;

export const Counter = styled.div`
  position: relative;
  display: flex;
  gap: ${props => props.theme.spacing.spacing_4};

  ${props => props.theme.breakpoints.tablet} {
    display: block;
  }

  &::before {
    content: counter(var(--table-counter)) ". ";

    ${props => props.theme.breakpoints.tablet} {
      position: absolute;
      top: 0;
      left: -${props => props.theme.spacing.spacing_16};
    }
  }
`;

export const ExtraCell = styled.td`
  display: none;

  ${props => props.theme.breakpoints.tablet} {
    display: table-cell;
  }
`;

export const DetailsButton = styled(Button)`
  .icon {
    transition: ${transition("transform")};
    transform: rotate(90deg);
  }
  [data-opened="true"] & .icon {
    transform: rotate(-90deg);
  }
`;
